import { render, staticRenderFns } from "./bulletinAddInner.vue?vue&type=template&id=b2bda5e0&"
import script from "./bulletinAddInner.vue?vue&type=script&lang=js&"
export * from "./bulletinAddInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports